import { HttpParams, HttpEvent } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractHttpService } from '../../service/http-abstract-service';
import { UserChangePasswordDto, AdminInvoiceResponseDto, RoleDto, UserDto } from './dto';


@Injectable({
	providedIn: 'root'
})
export class HttpAdminService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/management');
	}

	getAll(): Observable<UserDto[]> {
		return super.get(`/get`);
	}

	getAllRoles(): Observable<RoleDto[]> {
		return super.get(`/get-roles`);
	}

	getAdminByUsername(username: string): Observable<UserDto> {
		return super.get(`/${username}/get`);
	}

	editAdmin(admin: UserDto): Observable<AdminInvoiceResponseDto> {
		return super.post(`/${admin.id}/edit`, admin);
	}

	editAdminRoles(admin: UserDto): Observable<AdminInvoiceResponseDto> {
		return super.post(`/${admin.id}/edit-roles`, admin);
	}

	changeAdminStatus(adminId: number, status: 'Unblock' | 'Disable' | 'ReEnable'): Observable<AdminInvoiceResponseDto> {
		return super.get(`/${adminId}/${status}/action`);
	}

	addAdmin(admin: UserDto): Observable<AdminInvoiceResponseDto> {
		return super.post(`/add`, admin);
	}
}
